export const uk = {
    noData: 'Нет данных'
};
